import { render, staticRenderFns } from "./public.vue?vue&type=template&id=ef712896&scoped=true&"
var script = {}
import style0 from "./public.vue?vue&type=style&index=0&id=ef712896&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef712896",
  null
  
)

export default component.exports